import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "font-bold leading-9 mb-3" }, "Billing", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm mb-6" }, " Manage your billing information and payment methods. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_section = _resolveComponent("app-section")!

  return (_openBlock(), _createBlock(_component_app_section, { padding: "8" }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2
    ]),
    _: 1
  }))
}